// src/utils/normalizeSectorName.js

/**
 * normalizeSectorName
 *
 * Accepts ANY valid UK outward code or full postcode and returns the sector:
 *  - "PR1 3AB" → "PR1"
 *  - "AL10 9XY" → "AL10"
 *  - "BL0 1AA" → "BL0"
 *  - "EC1A 1BB" → "EC1A"
 *  - "WC2H 7LT" → "WC2H"
 *  - "E1W 3TT" → "E1W"
 *
 * Handles:
 *  - 1–2 letter area codes
 *  - 1–2 digit districts
 *  - Alphanumeric districts (EC1A, WC2H, E1W)
 *  - Zero‑digit districts (BL0)
 *  - Full postcodes with or without space
 *
 * Rejects only truly invalid inputs.
 */
export function normalizeSectorName(raw) {
  if (!raw || typeof raw !== "string") {
    return null;
  }

  // Remove spaces, tabs, newlines, carriage returns
  const cleaned = raw.replace(/[\s\r\n]+/g, "").toUpperCase();

  /**
   * FULL POSTCODE PATTERN
   *
   * Examples:
   *  - EC1A1BB
   *  - PR13AB
   *  - BL01AA
   *  - E1W3TT
   *
   * Group 1 = outward code (sector)
   */
  const full = cleaned.match(/^([A-Z]{1,2}\d[A-Z\d]?)\d[A-Z]{2}$/);
  if (full) {
    return full[1];
  }

  /**
   * OUTWARD CODE ONLY (SECTOR)
   *
   * Examples:
   *  - PR1
   *  - AL10
   *  - BL0
   *  - EC1A
   *  - WC2H
   *  - E1W
   */
  const outward = cleaned.match(/^([A-Z]{1,2}\d[A-Z\d]?)$/);
  if (outward) {
    return outward[1];
  }

  return null;
}

export default normalizeSectorName;
